import React,{useEffect, useState} from 'react';
import './ServicesPage.css';
import AOS from 'aos';
import WaterDropIcon from '@mui/icons-material/WaterDrop';


const SolarServices = () => {
    useEffect(() => {
        AOS.init();
        
            window.scrollTo(0, 0)
         
      }, []);

      const [features,setFeatures]=useState(false);
  return (
    <div className='container-fluid' id='solar-services'>

      <div className="row first-row" data-aos="fade-up" data-aos-offset="200"  data-aos-duration="1000">
        <div className="col text-col" data-aos="fade-right" data-aos-offset="200"  data-aos-duration="1000">
            <h1>We Provides Top-notch <br />
            Solar Water Pump <br />Automation Services </h1>
            <p> "<b>Unique Technologies </b>  specializes in solar water pump automation, offering cutting-edge systems for efficient and sustainable water management. Our solutions optimize resource usage, minimize downtime, and maximize productivity, ensuring reliable water supply for agricultural, residential, and commercial needs."</p>
        </div>
        <div className="col img-col"></div>
      </div>
      <div className="row" id='solar-pumping-system'>
        <h1>SOLAR WATER <br /> PUMPING SYSTEM</h1>
        <div className="solar-pumping-img">
            <img src="img-data/services-page/solar-services/solar-water-pumping.jpg" alt="" />
            <p>
Solar water pumping systems employ photovoltaic panels to power water pumps, offering sustainable solutions for irrigation, livestock watering, and domestic use in remote areas. By harnessing solar energy, these systems are eco-friendly, cost-effective, and reliable, serving as a renewable alternative to traditional diesel or electric-powered pumps, particularly in off-grid locations where access to electricity is limited. They contribute to water resource management and agricultural sustainability while reducing dependence on fossil fuels and minimizing environmental impact, making them an essential component of decentralized and resilient water supply infrastructure worldwide.</p>
        </div>

        <div className="system-introduction">
            <h1>System Introduction (AC System)</h1>
           
            <div className="system-intro-img">
                <p>Solar pumping System consists of four parts; solar panel, solar pumping inverter three-phase AC pump and water storage device. The solar pumping inverter converts DC power produced by solar panels to AC power which drives AC pump to pump water from borehole, river, lake etc. to the storage device. <br /> The inverter applies high efficiency MPPT algorithm to maximize power harvested from solar panels. It will make the system to maximize efficiency to get the water as much as possible.
The solar pumping system fulfills concept of low carbon, energy conservation, environmental protection to improve the living standard in water-deficinet area.</p>
<img src="img-data/services-page/solar-services/ac-system.png" alt="" />
            </div>
            <hr />
            <div className="more-functions">
                <h1>More Functions of Solar Pump System</h1>
                <p>Accessories will be added in solar pump sysem to realize  more functions. AC input function, high voltage solar charge to charge battery to save energy, AC filter to protect pump.</p>
                <img src="img-data/services-page/solar-services/more-functions.jpg" alt="" />
            </div>
        </div>

        <div className="system-application">
            <h1>System Application</h1>
            Solar pumpiong systems can be applied in the area with sunshine and areas with lack of electricity, such as;
            <p data-aos="fade-right" data-aos-offset="200"  data-aos-duration="1000"><WaterDropIcon style={{color:"skyblue"}}/> Daily water using</p>
            <p data-aos="fade-right" data-aos-offset="200"  data-aos-duration="1000"><WaterDropIcon style={{color:"skyblue"}}/> Agricultural irrigation (drop-irrigation, sprinkling irrigation, flood irrigation)</p>
            <p data-aos="fade-right" data-aos-offset="200"  data-aos-duration="1000"><WaterDropIcon style={{color:"skyblue"}}/> Forestry irrigation</p>
            <p data-aos="fade-right" data-aos-offset="200"  data-aos-duration="1000"><WaterDropIcon style={{color:"skyblue"}}/> Desert control</p>
            <p data-aos="fade-right" data-aos-offset="200"  data-aos-duration="1000"><WaterDropIcon style={{color:"skyblue"}}/> Pasture animal husbandry</p>
            <p data-aos="fade-right" data-aos-offset="200"  data-aos-duration="1000"><WaterDropIcon style={{color:"skyblue"}}/> Rural town and village water supply</p>
            <p data-aos="fade-right" data-aos-offset="200"  data-aos-duration="1000"><WaterDropIcon style={{color:"skyblue"}}/> Desalinization of sea water</p>
            <p data-aos="fade-right" data-aos-offset="200"  data-aos-duration="1000"><WaterDropIcon style={{color:"skyblue"}}/> Scenic fountain etc.</p>
        </div>
             
        <div className="system-features">
            <h1>System Features</h1>
            <div className="features">
                <div className='features-wrapper'>
                    <div className='feature-1'><img src="/img-data/services-page/solar-services/feature-1.png" alt=""/>
                    <p>Reliable solution for agricultural irrigation, daily water, desert control in no-electricity and water deficient area.</p>
                    </div>
                    <div className='feature-2'><img src="/img-data/services-page/solar-services/feature-2.png" alt=""/>
                    <p>Wide application with all kinds of PV modules and 3-phase AC pumps.</p>
                    </div>
                    <div className='feature-3'><img src="/img-data/services-page/solar-services/feature-3.png" alt=""/>
                    <p>IP 65 for outdoors application.</p>
                    </div>
                    <div className='feature-4'><img src="/img-data/services-page/solar-services/feature-4.png" alt=""/>
                    <p>Maximum Operation temperature 60<sup>o</sup>C</p>
                    </div>
                    <div className='feature-5'><img src="/img-data/services-page/solar-services/feature-5.png" alt=""/>
                    <p>GPRS remote monitoring for real time operation status and control on/off.</p>
                    </div>
                    <div className='feature-6'><img src="/img-data/services-page/solar-services/feature-6.png" alt=""/>
                    <p>Excellent performance during cloudly weather within 5% more water output compared competitors.</p>
                    </div>
                    <div className='feature-7'><img src="/img-data/services-page/solar-services/feature-7.png" alt=""/>
                    <p>ROI is only less than 2 years compared to diesel Generator.</p>
                    </div>
                    <div className='feature-8'><img src="/img-data/services-page/solar-services/feature-8.png" alt=""/>
                    <p>FUll automatic unattended operation with perfect protection functions for long lifespan 25 years.</p>
                    </div>
                    <div className='feature-9'><img src="/img-data/services-page/solar-services/feature-9.png" alt=""/>
                    <p>3 years warranty for complete system, 10 years for PV modules.</p>
                    </div>
                </div>
            </div>
        </div>
      </div>

      {/* <div className="row top-heading-row" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
            <h2>Our Six Step <br />
            working Process for Solar Services</h2>
        </div>
    <div className="row second-row" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
     <div className="col oddcol first-col">
        <div className="row">
            <div className="col text-col" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000">
                <h3>1.Consultation & Assessment: </h3>
                <p>We begin by evaluating energy requirements and site conditions, engaging in thorough discussions with clients to understand their unique needs and objectives for solar integration.</p>
            </div>
            <div className="col first-img-col"></div>
        </div>
     </div>
     <div className="col evencol second-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
     <div className="row">
     <div className="col second-img-col"></div>
            <div className="col text-col" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000">
                <h3>2.Design Proposal:  </h3>
                <p>Following the assessment, we create personalized solar system designs, presenting detailed proposals outlining the recommended solutions tailored to each client's specifications..</p>
            </div>

        </div>
     </div>
     <div className="col oddcol third-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
     <div className="row">
            <div className="col text-col" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000">
                <h3>3.Permitting & Approvals:  </h3>
                <p>Unique Technologies manages the entire permitting process, navigating regulatory requirements and obtaining necessary approvals from local authorities and utilities to ensure seamless project execution.</p>
            </div>
            <div className="col third-img-col"></div>
        </div>
     </div>
     <div className="col evencol fourth-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
     <div className="row">
     <div className="col fourth-img-col"></div>
            <div className="col text-col" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000">
                <h3>4.Installation & Commissioning:  </h3>
                <p>Our skilled technicians carry out the installation process with precision, adhering to industry best practices and safety standards to ensure the efficient and effective deployment of the solar system.</p>
            </div>

        </div>
     </div>
     <div className="col oddcol fifth-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
     <div className="row">
            <div className="col text-col" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000">
                <h3>5.Monitoring & Maintenance: </h3>
                <p>We implement robust monitoring systems to track performance post-installation, coupled with regular maintenance checks to optimize system efficiency, detect issues early, and prolong the lifespan of the solar infrastructure..</p>
            </div>
            <div className="col fifth-img-col"></div>
        </div>
     </div>
     <div className="col evencol sixth-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
     <div className="row">
     <div className="col sixth-img-col"></div>
            <div className="col text-col" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000">
                <h3>6.Customer Support & Education:  </h3>
                <p>Throughout the entire process, Unique Technologies provides dedicated customer support, offering guidance and resources to empower clients with the knowledge needed to maximize the benefits of their solar investment.</p>
            </div>

        </div>
     </div>
    </div> */}
    </div>
  )
}

export default SolarServices

